// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/ui.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/ui.tsx");
  import.meta.hot.lastModified = "1735909117567.1995";
}
// REMIX HMR END

import { Alert, Box, Skeleton } from '@mantine/core';
import { useAsyncError } from '@remix-run/react';
import { TbExclamationCircleFilled } from 'react-icons/tb';
export function SkeletonLoader(props) {
  return <Box mt={props.mt} mb={props.mb}>
			<Skeleton height={8} radius="xl" />
			<Skeleton height={8} mt={6} radius="xl" />
			<Skeleton height={8} mt={6} radius="xl" />
			<Skeleton height={8} mt={6} radius="xl" />
			<Skeleton height={8} mt={6} width="70%" radius="xl" />
		</Box>;
}
_c = SkeletonLoader;
export function AwaitErrorElement() {
  _s();
  const error = useAsyncError();
  return <Alert my="md" variant="light" color="red" title={'Error'} icon={<TbExclamationCircleFilled size="1rem" />}>
			{error && 'message' in error && error.message}
		</Alert>;
}
_s(AwaitErrorElement, "RI7BwSlFlPOu1etltmfksefC3Tc=", false, function () {
  return [useAsyncError];
});
_c2 = AwaitErrorElement;
var _c, _c2;
$RefreshReg$(_c, "SkeletonLoader");
$RefreshReg$(_c2, "AwaitErrorElement");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;